export default "__VITE_ASSET__CnrC$OkK__"